import { render, staticRenderFns } from "./AccessDeniedPage.vue?vue&type=template&id=7b1a7aa6&scoped=true&"
import script from "./AccessDeniedPage.vue?vue&type=script&lang=js&"
export * from "./AccessDeniedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1a7aa6",
  null
  
)

export default component.exports